import React, { useState } from "react";

export default function Hilight(props) {
  const [data, setData] = useState([
    {
      banner: "hilight_banner_b224.jpg",
      title: "Furniture Living & Design 2024",
      text: "เฟอร์นิเจอร์ทุกชนิด เฟอร์นิเจอร์บิ้วท์อิน-และลอยตัว สินค้าตกแต่งบ้าน และอุปกรณ์อำนวนความสะดวกภายในบ้าน",
      date: "25 พ.ค. - 2 มิ.ย. 2567",
    },
    /*
    {
      banner: "hilight_banner_240122_2.jpg",
      title: "ELECTRONICA Amazing Sale @ BITEC 2024",
      text: "งานแสดงสินค้า เครื่องใช้ไฟฟ้าในบ้านและครัวเรือน ลดราคาสูงสุด 70%",
      date: "9-17 มี.ค. 2567",
    },
    {
      banner: "hilight_banner_b124e.jpg",
      title: "เพาเวอร์บาย แกรนด์ เซลล์",
      text: "งานแสดงสินค้า เครื่องใช้ไฟฟ้าในบ้าน สินค้า IT และ Gadget ลดยกใหญ่",
      date: "9-17 มี.ค. 2567",
    },
    */
  ]);

  return (
    <section className="home_hilight">
      <div className=" bg-gray-300 py-6">
        <h1 className="text-center text-2xl md:text-4xl">
          ไฮไลท์งานแสดงสินค้า
        </h1>
        <div className="flex gap-4 md:gap-8 py-6 overflow-x-scroll overflow-hidden snap-mandatory snap-x  md:justify-center px-3 md:px-[100px]">
          {data.map((d, i) => (
            <div
              className="bg-white p-3 w-[300px] h-[450px] snap-center snap-always shadow-md flex-none"
              key={"card-ex-" + i}
            >
              <div className="w-full aspect-square">
                <img
                  src={
                    "https://worldfair.blob.core.windows.net/webcard/" +
                    d.banner
                  }
                  className="object-cover w-full"
                />
              </div>
              <div className="mt-3 flex flex-col justify-between h-[140px]">
                <div>
                  <strong>{d.title}</strong>
                </div>
                <div>{d.text}</div>
                <div>
                  <strong>{d.date}</strong>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
